import { MobileHamburgerMajor } from "@shopify/polaris-icons";
import { IMenuItems, MenuItemType } from "./MenuModel";
const tiktok: IMenuItems = {
  id: "widget",
  title: "TikTok Widget",
  type: MenuItemType.Group,
  icon: MobileHamburgerMajor,
  url: "widget",
  featureHighlight: true,
  defaultExpand: true,
  children: [
    {
      id: "create-widget",
      title: "Create widget",
      type: MenuItemType.Group,
      url: "/create-widget",
      enableFeatureHighlightUrl: true
    },
    {
      id: "my-widget",
      title: "My widgets",
      type: MenuItemType.Group,
      url: "/my-widget",
      chip: {
        nameReducer: "TiktokWidgetReducer"
      }
    }
  ]
};

export default tiktok;
